import FJPool from './FJPool';

class FJPoolVideo extends FJPool {
    _clearItem(value) {
        // 传入的 value（Video）需要在外界解绑所有事件
        value.src = '';
    }

    _createItem() {
        return { value: document.createElement('video'), idle: true };
    }
}

export default FJPoolVideo;
